// extracted by mini-css-extract-plugin
export default {"wrapper":"title_wrapper__jLyZg","title":"title_title__wlzAv","goBackIcon":"title_goBackIcon__xveN2","goBackText":"title_goBackText__jE-XH"};